module.exports = __webpack_public_path__ + "img/card.cea54064.png";